import React from 'react';
import Image from 'next/image';

import LogoImage from '@public/logo.svg';

const Logo: React.FC = () => <Image src={LogoImage} height={50} width={110} />;

export default Logo;
